export const signupFields = ['name', 'login', 'password'];

export const signinFields = ['login', 'password'];

export const taskFields = ['taskTitle', 'taskDescription'];
